module.exports = __webpack_public_path__ + "static/fr-dl-slider-43742cdbc4ae0c9c11b5f624f84995dc.png";